import { getServiceTaskCategories } from 'utils/helper/product';
import { taskCategoryFilter } from '../Template/filters';

export const filters = ({ services }) => {
  return {
    RegularFilters: [
      {
        label: 'Archived',
        field: 'archived',
        type: 'toggle',
      },
      // { To be implemented when we add this to users
      //   label: 'Qualification Required',
      //   field: 'qualificationRequired',
      //   type: 'toggle',
      // },
      taskCategoryFilter(getServiceTaskCategories({ services })),
    ],
  };
};
